import { createContext } from 'react';

export const Dictionary = createContext();
export const Seo = createContext();
export const Settings = createContext();
